// German for the client timeline: the stream, its filters, the event editor and the toasts.
import { registerDe } from '../i18n/index.js';

registerDe({
  // toasts
  'Reconstruction started — the agent is reading the library (run #{id}).': 'Rekonstruktion gestartet — der Agent liest die Bibliothek (Lauf #{id}).',
  'Reconstruction finished — {events}, {facts} recorded. Every row is yours to edit or delete.': 'Rekonstruktion abgeschlossen — {events}, {facts} erfasst. Jede Zeile können Sie bearbeiten oder löschen.',
  '{n} event': '{n} Ereignis',
  '{n} events': '{n} Ereignisse',
  '{n} fact': '{n} Fakt',
  '{n} facts': '{n} Fakten',
  'Reconstruction {status} — {events} event(s), {facts} fact(s) landed before it stopped.': 'Rekonstruktion {status} — {events} Ereignis(se), {facts} Fakt(en) sind vor dem Stopp gelandet.',
  'Reconstruction {status}.': 'Rekonstruktion {status}.',
  'error': 'fehlgeschlagen',
  'aborted': 'abgebrochen',
  'timeout': 'Zeitüberschreitung',
  'The event needs a title.': 'Das Ereignis braucht einen Titel.',
  'When did it happen? occurred-at is the date per the source, never today by default.': 'Wann ist es passiert? Das Datum ist das der Quelle, nie standardmässig heute.',
  'Event updated': 'Ereignis aktualisiert',
  '{ref} recorded': '{ref} erfasst',
  '{ref} deleted': '{ref} gelöscht',
  // document rows
  'superseded': 'ersetzt',
  'Supersession lineage — explicit links and dates, never filename version labels': 'Ersetzungskette — explizite Verknüpfungen und Daten, nie Versionsbezeichnungen im Dateinamen',
  // event rows
  'open · with {owner}': 'offen · bei {owner}',
  'open · owner unrecorded': 'offen · Verantwortliche(r) nicht erfasst',
  'discharged {date}': 'eingelöst {date}',
  'Record that the promise was kept — a date and the artefact that kept it': 'Festhalten, dass die Zusage eingehalten wurde — ein Datum und das Artefakt, das sie einlöste',
  'Discharge': 'Einlösen',
  'Edit event': 'Ereignis bearbeiten',
  'Delete event': 'Ereignis löschen',
  'No source document anchors this event — fine, but anchored is better': 'Kein Quelldokument verankert dieses Ereignis — in Ordnung, aber verankert ist besser',
  'unanchored': 'unverankert',
  'Recorded by the reconstruction agent — always yours to correct': 'Vom Rekonstruktions-Agenten erfasst — jederzeit von Ihnen korrigierbar',
  'agent': 'Agent',
  'kept by': 'eingelöst durch',
  // layout
  'document': 'Dokument',
  'documents': 'Dokumente',
  'event': 'Ereignis',
  'events': 'Ereignisse',
  'Add event': 'Ereignis hinzufügen',
  'Agent pass over the whole library: events for evidenced happenings, facts with source + quote. Auto-applied, audited, always yours to correct.': 'Agenten-Durchgang über die ganze Bibliothek: Ereignisse für belegte Vorgänge, Fakten mit Quelle + Zitat. Automatisch übernommen, protokolliert, jederzeit von Ihnen korrigierbar.',
  'Reconstructing…': 'Wird rekonstruiert…',
  'Reconstruct timeline': 'Zeitachse rekonstruieren',
  'Timeline': 'Zeitachse',
  'all engagements': 'alle Aufträge',
  'From': 'Von',
  'To': 'Bis',
  'All': 'Alle',
  'Documents in this folder': 'Dokumente in dieser Ablage',
  '{kind} events': 'Ereignisse: {kind}',
  'Nothing matches these filters': 'Nichts entspricht diesen Filtern',
  'Nothing on the timeline yet': 'Noch nichts auf der Zeitachse',
  'Widen the date range or clear a chip.': 'Erweitern Sie den Zeitraum oder entfernen Sie einen Filter.',
  'Every library document is automatically an entry here. Upload documents, or add an event by hand.': 'Jedes Bibliotheksdokument ist hier automatisch ein Eintrag. Laden Sie Dokumente hoch oder fügen Sie ein Ereignis von Hand hinzu.',
  // editor
  'Kind': 'Art',
  'Date': 'Datum',
  'Time': 'Uhrzeit',
  'Title': 'Titel',
  "What happened — 'NDA signed', 'Kickoff agreed for July'": 'Was passiert ist — «NDA unterzeichnet», «Kickoff für Juli vereinbart»',
  'Summary': 'Zusammenfassung',
  'Engagement': 'Auftrag',
  '— none (client-wide) —': '— keiner (kundenweit) —',
  'Participants — one per line,': 'Teilnehmende — eine Person pro Zeile,',
  'Source documents — the evidence this event anchors to': 'Quelldokumente — die Belege, an denen dieses Ereignis verankert ist',
  'Loading the library…': 'Bibliothek wird geladen…',
  'The library is empty — the event will be recorded unanchored.': 'Die Bibliothek ist leer — das Ereignis wird unverankert erfasst.',
  'Cancel': 'Abbrechen',
  'Saving…': 'Wird gespeichert…',
  'Save event': 'Ereignis speichern',
  'Deleting…': 'Wird gelöscht…',
  'Delete': 'Löschen',
  'Delete “{label}”? The documents it anchored to stay in the library — only the event goes. The audit log keeps the record.': '«{label}» löschen? Die verankerten Dokumente bleiben in der Bibliothek — nur das Ereignis geht. Der Prüfpfad behält den Eintrag.',
  // EVENT_KINDS (option labels, badges, chips)
  'meeting': 'Besprechung',
  'decision': 'Entscheidung',
  'signature': 'Unterschrift',
  'commitment': 'Zusage',
  'milestone': 'Meilenstein',
  'participant': 'Teilnehmer',
  'note': 'Notiz',
  // folder chips (document folders, plus the client-side 'unclassified')
  'correspondence': 'Korrespondenz',
  'agreement': 'Vereinbarung',
  'financial': 'Finanzen',
  'specification': 'Spezifikation',
  'presentation': 'Präsentation',
  'image': 'Bild',
  'deliverable': 'Arbeitsergebnis',
  'reference': 'Referenz',
  'unclassified': 'nicht klassifiziert',
}, 'ClientTimeline');
